<script setup lang="ts">
import localConfig from '~/config/locale-config'
import { displayLanguageSelector } from '~/helpers/localization'

const NEW_LOCALE_CODE_MAP = {
  [localConfig['en-CA'].code]: 'fr',
  fr: 'en-CA',
} as const

const LINK_LABEL_MAP = {
  fr: 'Français',
  'en-CA': 'English',
} as const

function transformLocalePath() {
  const switchLocalePath = useSwitchLocalePath()
  let newPath = switchLocalePath(newLocaleCode)
  const newPathSections = newPath?.split('?')
  if (newPathSections[0].endsWith('/fr')) {
    newPath = `${newPathSections[0]}/${newPathSections[1] ? `?${newPathSections[1]}` : ''}`
  }
  return newPath
}

type LanguageSwitcherProps = {
  theme?: 'dark' | 'light'
}
const props = withDefaults(defineProps<LanguageSwitcherProps>(), { theme: 'light' })

const { locale } = useI18n()
const localeCodes = ['en-CA', 'fr', 'en-NZ', 'en-AU']

const newLocaleCode = NEW_LOCALE_CODE_MAP[locale.value]
const linkLabel = LINK_LABEL_MAP[newLocaleCode]
</script>

<template>
  <Anchor
    :url="transformLocalePath()"
    v-if="displayLanguageSelector(locale, localeCodes)"
    :ga-options="{
      eventName: 'custom.menu.link',
      group: 'actions menu',
      label: 'Change language',
    }"
    :log-click="true"
  >
    <svg-icon :name="`mhj:${theme === 'dark' ? 'globe' : 'globe-dark'}`" />
    {{ linkLabel }}
  </Anchor>
</template>

<style lang="postcss"></style>
